var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsOptional, IsUUID } from 'class-validator';
import { OfficeLocationFullSizeDto } from '../../offices/index.js';
/**
 * @deprecated Use {@link RegistrationLinkResponseDto} from `@therame/shared` instead.
 */
export class RegistrationLinkFullSizeDto {
    id;
    createdAt;
    updatedAt;
    deletedAt;
    officeLocation;
    officeLocationId;
    token;
}
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], RegistrationLinkFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], RegistrationLinkFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], RegistrationLinkFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Object)
], RegistrationLinkFullSizeDto.prototype, "deletedAt", void 0);
__decorate([
    IsObject(),
    IsOptional(),
    Type(() => OfficeLocationFullSizeDto),
    Exclude(),
    __metadata("design:type", Object)
], RegistrationLinkFullSizeDto.prototype, "officeLocation", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], RegistrationLinkFullSizeDto.prototype, "officeLocationId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], RegistrationLinkFullSizeDto.prototype, "token", void 0);
//# sourceMappingURL=registration-link.full-size.dto.js.map